import httpClient from '@/apis/base/httpclient';
import BUApi from '../bu/_buApi';

class MonitorUsageApi extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'monitorusages';

  /**
   * Thêm mới
   */
  async insert(payload) {
    try {
      const request = {
        url: this.getAPIUrl() + '/add',
        data: payload,
      };
      var res = await httpClient.postAsync(request);
      return res;
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Thêm mới hàng loạt entity
   * ndhieu3 20.11.2023
   * @param {*} payload 
   * @returns 
   */
  async insertBatchAsync(payload){
    try {
      const request = {
        url: this.getAPIUrl() + '/add-multiple',
        data: payload,
      };
      var res = await httpClient.postAsync(request);
      return res;
    } catch (e) {
      console.log(e);
    }
  }
}
export default new MonitorUsageApi();
